// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import { htmlDecode } from '../../_common/api/utility';
import Input from '../../_common/form/Input';
import Loading from '../../_common/Loading';
import Card from '../Card';
import { HamQuest } from '../../../App';

const Support = ({ ...props }) => {

    const [support, setSupport] = useState(null)

    useEffect(() => {
        HamQuest.get(QuestRoute.merchant.support)
            .then(res => setSupport({
                email: res.supportEmail,
                phone: res.supportPhone,
                faq: htmlDecode(res.supportFaqs),
            }))
    }, [])

    if (!support) return <Loading />;

    return (
        <Card>
            {
                support.email ?
                    <Input
                        standalone
                        label='Support Email'
                        value={support.email}
                        readOnly
                        onClick={() => window.location = `mailto:${support.email}`}
                    /> : null
            }
            {
                support.phone ?
                    <Input
                        standalone
                        label='Support Phone'
                        value={support.phone}
                        readOnly
                        onClick={() => window.location = `tel:${support.phone}`}
                    /> : null
            }
            <div dangerouslySetInnerHTML={{ __html: support.faq }} />
        </Card>
    );
}

export default Support;